import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import TicketList from './components/Tickets/TicketList';
import CreateTicket from './components/Tickets/CreateTicket';
import TicketDetail from './components/Tickets/TicketDetail';
import ChatBot from './components/ChatBot/ChatBot';

const CHATBOT_ROUTES = ['/dashboard', '/submit', '/tickets'];

function AppInner() {
  const { pathname } = useLocation();
  const showChatBot = CHATBOT_ROUTES.some((r) => pathname.startsWith(r));

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<TicketList />} />
        <Route path="/submit" element={<CreateTicket />} />
        <Route path="/tickets/:id" element={<TicketDetail />} />
      </Routes>
      {showChatBot && <ChatBot />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppInner />
    </Router>
  );
}

export default App;